module.exports = __webpack_public_path__ + "media/aquatic.a8d242f5.wav";